import axios from 'axios';

const state = {
  accessToken: '',
  refreshToken: '',
  user: null,
};

const getters = {
  isLoggedIn: state => !!state.accessToken && !!state.refreshToken,
  getAuthToken: state => state.accessToken,
  getRefreshToken: state => state.refreshToken,
  getLoggedInUser: state => state.user,
};

const mutations = {
  login: (state, res) => {
    state.accessToken = res.accessToken;
    state.refreshToken = res.refreshToken;
    state.user = res.user;
  },
  logout: state => {
    state.accessToken = '';
    state.refreshToken = '';
    state.user = null;
  },
  updateMyProfile: (state, updatedUser) => {
    state.user = { ...state.user, ...updatedUser };
  },
};

const actions = {
  async login({ commit }, data) {
    const loginResp = (
      await axios.post('api/token/', {
        email: data.email,
        password: data.password,
      })
    ).data;

    commit('login', {
      accessToken: loginResp.access,
      refreshToken: loginResp.refresh,
      user: loginResp.user,
    });

    return loginResp;
  },

  async logout({ commit }) {
    commit('logout');
  },

  async getMe() {
    const res = await axios.get('api/users/me/');
    return res.data.data;
  },

  async updateMyProfile({ commit }, data) {
    await axios.patch('api/users/update-profile/', data);
    commit('updateMyProfile', data);
  },

  async updateMyPassword(_obj, data) {
    await axios.patch('api/users/update-password/', data);
  },

  async resetPassword(_obj, data) {
    return axios.post('api/password-reset/', data);
  },

  async resetPasswordConfirm(_obj, data) {
    return axios.post('api/password-reset/confirm/', data);
  },

  async validateResetPasswordToken(_obj, data) {
    return axios.post('api/password-reset/validate_token/', data);
  },
};

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
